import t from "./eq.js";
var f = t;
function o(n, r) {
  for (var e = n.length; e--; )
    if (f(n[e][0], r))
      return e;
  return -1;
}
var s = o;
export {
  s as default
};
//# sourceMappingURL=_assocIndexOf.js.map
